// extracted by mini-css-extract-plugin
export default {"posIntegration":"POSIntegration_posIntegration__uxBJz","heading":"POSIntegration_heading__CsQn4","img":"POSIntegration_img__ikSmQ","section":"POSIntegration_section__1Gumh"};